import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { AssessementContext } from "../../../AssessmentContext";
import { exams as examsApi } from "../../../../../../api/exams";
import PhysicalExams from "./PhysicalExams";
import Loader from "../../../../../../components/loader/Loader";
import Pagination from "../../../../../../components/Pagination/Pagination";
import Input from "../../../../../../components/input/Input";
import EmptyData from "../../../../../../components/EmptyData";
import { useTranslation } from "react-i18next";

export const updateAnswers = ({
  answers, questions, updateAnswersMutation,
  questionsDuration
}) => {
  updateAnswersMutation.mutate({
    userId: JSON.parse(sessionStorage.getItem("user"))?.user?.user_id || window.sessionStorage.getItem("user_id"),
    assessmentId: window.sessionStorage.getItem("active-assessment-id"),
    userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
    data: {
      ...updatedSavedAnswerPayload(
        [
          ...answers.map((answer) => {
            return {
              duration: answer?.duration,
              answer_id: answer?.answer_id,
              question_id: answer?.question_id,
              answer_text: answer?.answer_text,
            };
          }),
        ],
        questionsDuration,
        questions
      ),
      time_left: parseInt(sessionStorage.getItem("client_side_time_left")),
    },
  });
};

const UpcommingAssessment = () => {

  const [type, setType] = useState("physical");
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [search, setSearch] = useState('')
  const { assessment, setAssessment } = useContext(AssessementContext);
  const location = useLocation();
  const [hasExams, setHasExams] = useState(true);
  const { t } = useTranslation()
  const [examLocked, setExamLocked] = useState(false)
  const userId = user?.user?.user_id || window.sessionStorage.getItem("user_id")

  const {
    isLoading,
    data: exams,
    refetch,
  } = useQuery(
    ["user-group-assessment", type, currentPage, perPage, search, userId],
    async () => {
      const data = await examsApi.getAssesmentsv3(
        { type, id: userId, currentPage, perPage, search }
      );
      return data;
    },
    {
      onSuccess: (data) => {
        if (data?.data?.upcoming_exams?.length) {
          setHasExams(false);
        }
        setAssessment({ ...assessment, viewAsessments: { ...data?.data } });
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      select: res => res?.data
    }
  );

  useEffect(() => {
    const contactButton = document.querySelector(
      ".woot-widget-bubble.woot-elements--right"
    );
    //-------- hide and contact us button when exam is taken ----------------------//
    if (contactButton) {
      if (location.pathname.includes("candidate-assessment")) {
        contactButton.style.visibility = "hidden";
      } else {
        contactButton.style.visibility = "visible";
      }
    }
  }, [location.pathname]);

  return (
    <>
      {" "}
      {examLocked && (
        <UnlockAssessmentModal
          closeModal={setExamLocked}
          refetch={refetch}
        // getExamsMutation={getExamsMutation}
        // id={id}
        />
      )}
      {(
        <div>
          <div className="text-white md:flex items-center justify-between bg-darkBlue my-4 py-4 px-4 mx-1 rounded-lg">
            <h5 className="max-[500px]:mb-3">
              {t('upcoming-exams')} &nbsp;{" "}
              ({exams?.meta?.total})
            </h5>
            <div className="w-[300px] text-slate-950">
              <Input
                type='search'
                placeholder={t('search-exam')}
                onChange={event => setSearch(event.target.value)}
              />
            </div>
          </div>
          {
            isLoading ? <Loader /> :
              exams?.meta?.total ?
                <>
                  {
                    <PhysicalExams
                      exams={exams?.upcoming_exams} isLoading={isLoading}
                      currentPage={currentPage}
                      perPage={perPage}
                      setCurrentPage={setCurrentPage}
                      setPerPage={setPerPage}
                      refetch={refetch}
                    />
                  }
                </>
                :
                <EmptyData
                  text={
                    search !== '' ? t('no-result') :
                      t('no-upcoming-exam')
                  }
                />
          }
          <Pagination
            data={exams?.meta}
            perPage={perPage}
            pageNo={currentPage}
            setPageNo={setCurrentPage}
            setPerPage={setPerPage}
          />
        </div>
      )}
    </>
  );
};

export default UpcommingAssessment;
